import PropTypes from 'prop-types'

const HistogramDataPropType = PropTypes.array.isRequired

export default HistogramDataPropType
